import FallbackEventCard from './_fallback-event-card.js'
import FallbackEventCardType from './_fallback-event-card-type.js'

export default {
  name: 'SportFallbackEventCard',
  values: {
    view: {
      configSet: FallbackEventCard,
      configValues: {},
    },
    $mixin: [
      {
        configSet: FallbackEventCardType,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
